<template>
  <form class="create-account-form" @submit.prevent="onSubmit">
    <dx-form :form-data="formData" :disabled="loading">
      <dx-item
        data-field="loggedInPassword"
        editor-type="dxTextBox"
        :editor-options="{ stylingMode: 'filled', placeholder: 'your current password', mode: 'password' }"
      >
        <dx-required-rule message="Your Password is required to continue" />
        <dx-label :visible="false" />
      </dx-item>

      <dx-item>
        <template #default>
          <div class='policy-info'>
            To assign a new password to any account, it's required to type your current password, as well as the new password in this form.  
          </div>
        </template>
      </dx-item>

      <dx-item
        data-field="assignedPassword"
        editor-type="dxTextBox"
        :editor-options="{ stylingMode: 'filled', placeholder: 'new password', mode: 'password' }"
      >
        <dx-required-rule message="Assigned Password is required to continue" />
        <dx-label :visible="false" />
      </dx-item>
      <dx-item
        data-field="confirmationPassword"
        editor-type="dxTextBox"
        :editor-options="{ stylingMode: 'filled', placeholder: 'new password confirmation', mode: 'password' }"
      >
        <dx-required-rule message="Password confirmation is required" />
        <dx-custom-rule
          message="Password and confirmation are different"
          :validation-callback="confirmPassword"
        />
        <dx-label :visible="false" />
      </dx-item>
      <dx-button-item>
        <dx-button-options
          width="100%"
          type="default"
          template="createAccount"
          :use-submit-behavior="true"
        >
        </dx-button-options>
      </dx-button-item>
      <template #createAccount>
        <div>
          <span class="dx-button-text">
              <dx-loadIndicator v-if="loading" width="24px" height="24px" :visible="true" />
              <span v-if="!loading">Change Password</span>
          </span>
        </div>
      </template>
    </dx-form>
  </form>
</template>

<script>
import DxForm, {
  DxItem,
  DxLabel,
  DxButtonItem,
  DxButtonOptions,
  DxCustomRule,
  DxRequiredRule,
} from 'devextreme-vue/form';
import DxLoadIndicator from 'devextreme-vue/load-indicator';
import notify from 'devextreme/ui/notify';
//import { useRouter } from 'vue-router';
import { ref, reactive } from 'vue';
import auth from "../services/auth";

export default {
  components: {
    DxForm,
    DxItem,
    DxLabel,
    DxButtonItem,
    DxButtonOptions,
    DxRequiredRule,
    DxCustomRule,
    DxLoadIndicator
  },
  props: { username: String },

  emits: ['request-finish'],
  setup(props, { emit }) {
    const loading = ref(false);
    const formData = reactive({
      loggedInPassword: null,
      assignedPassword: null,
      confirmationPassword: null,
    });

    const onSubmit = async () => {
      loading.value = true;
       try{
        const result = await auth.changeLocalPassword(formData.loggedInPassword, props.username, formData.assignedPassword);
        if (result.isOk) {
          notify(result.message||'Password Changed!', 'success', 5000);
          emit('request-finish', true);
          formData.loggedInPassword=null;
          formData.assignedPassword=null;
          formData.confirmationPassword=null;
        } else {
          notify(result.message||'unknown error', 'error', 5000);
          emit('request-finish', false);
        }
      }
      catch(e) {
        notify(e.message||'unknown error', 'error', 5000);
      }
      loading.value = false;
    };

    function confirmPassword(e) {
      return e.value === formData.assignedPassword;
    }
    
    return {
        formData,
        loading,
        onSubmit,
        confirmPassword
    }
  }
}
</script>

<style lang="scss">
@import "../themes/generated/variables.base.scss";

.create-account-form {
  .policy-info {
    margin: 10px 0;
    color: rgba($base-text-color, alpha($base-text-color) * 0.7);
    font-size: 14px;
    font-style: normal;

    a {
      color: rgba($base-text-color, alpha($base-text-color) * 0.7);
    }
  }

  .login-link {
    color: $base-accent;
    font-size: 16px;
    text-align: center;
  }
}
</style>
